module.exports = __webpack_public_path__ + "image/human_2_4425a.png";